import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ysnwrcjujg: FaireBrandEntity = {
  token: "b_ysnwrcjujg",
  type: "brand",
  name: "Mccolin",
  avatarUrl:
    "https://cdn.faire.com/fastly/cd14e4da668bae974a587d889d7f32f5e9e3890537c37514108fb6bd0c9d5280.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3b21cbfabf991816f2a7a4c68c52cdd8b5f73820b5dbceca408c4d516e3abe58.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cd14e4da668bae974a587d889d7f32f5e9e3890537c37514108fb6bd0c9d5280.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3b21cbfabf991816f2a7a4c68c52cdd8b5f73820b5dbceca408c4d516e3abe58.png",
  location: " Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 3.9,
  reviewCount: 61,
  isInsider: true,
  description:
    "HELLO! MCCOLIN offers stylish wholesale womenswear with a focus on casual, modern designs for everyday confidence.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:46.409Z",
    importedBy: "entity-db-cli",
  },
};
